import React from 'react'
import useStore from 'state/knovStore'
import WithTooltip from 'components/shared/WithTooltip'
import Button from 'components/shared/buttons/Button'
import styles from 'components/shared/filter-options.module.scss'
import { getCenterPanel } from 'state/imperativeApis/swiperApi'

export default function AddStream({ contextStyles, closeStreamSelector, panelId, filter }) {
    const openCreateStreamModal = useStore(
        state => state.actions.modalActions.openCreateStreamModal,
    )

    const handleClick = () => {
        const currentPanelId = panelId || getCenterPanel()?.panelId
        openCreateStreamModal(currentPanelId, filter)
        closeStreamSelector()
    }

    return (
        <div className={styles.addStreamComp} onClick={handleClick}>
            <Button icon="fa fa-plus" text="New" contextStyles={contextStyles} />
        </div>
    )
}
